export default __webpack_public_path__ + "0a7f0c5976a04a32d97e6278b7924f0f.jpg";